import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatStepper } from "@angular/material/stepper";
import { Subject } from 'rxjs';
import { cloneDeep, isEqual } from 'lodash';
import moment from 'moment';
import { PointStoreProductValidationService } from 'src/app/gamification/marketplace/admin/services/point-store-product-validation.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvPointStoreProductService } from '../../services/cv-point-store-product.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStoreProductEditService } from 'src/app/gamification/marketplace/admin/services/point-store-product-edit.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PointStoreProductEditSaveService } from 'src/app/gamification/marketplace/admin/services/point-store-product-edit-save.service';
import { PointStoreProductSaveValidation } from '../../models/point-store-product-validation.model';
import { PointStoreNavigationBarService } from 'src/app/gamification/marketplace/admin/services/point-store-navigation-bar.service';
import { AssignmentDefinition, GroupDTO } from '../cv-point-store-product-assignment-cxone/cv-point-store-product-assignment-cxone.model';

@Component({
  selector: 'cv-point-store-new-edit-product',
  templateUrl: './cv-point-store-new-edit-product.component.html',
  styleUrls: ['./cv-point-store-new-edit-product.component.scss']
})
export class CvPointStoreNewEditProductComponent implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit  {
  
  @Input() callParentFunctions: () => void;

  @ViewChild('stepper') stepper: MatStepper;
  loadingProgressWrapper: boolean = true;
  isCxone: boolean = false;
  progressbarFilledIn: number = 0;
  stepsNumber: number = 0;
  stepperIndicatorBar: string = '0px';
  stepperContainerSize: number = 0;
  stepperObserverContainer: any = null;
  isEdit: boolean = false;
  steppersCompleted = [
    false,
    false,
    false,
    false,
    false
  ];
  pspes: any = null;

  //object to validate if the product is dirty
  modifiedProductCopy: any = null;

  private selectedAssignment: AssignmentDefinition = null;

  //form groups

  //step 1
  stepOneFormGroup: FormGroup = new FormGroup({});
  stepOneSubject: Subject<boolean> = new Subject();
  stepOneLabelMessage: string = '';
	@ViewChild('stepOneContainer') stepOneContainer: ElementRef<HTMLElement>;
	@ViewChild('stepOneLabel') stepOneLabel: ElementRef<HTMLElement>;


  //step 2
  stepTwoFormGroup: FormGroup = new FormGroup({});
  stepTwoLabelMessage: string = '';
	@ViewChild('stepTwoContainer') stepTwoContainer: ElementRef<HTMLElement>;
	@ViewChild('stepTwoLabel') stepTwoLabel: ElementRef<HTMLElement>;

  //step 3
  stepThreeFormGroup: FormGroup = new FormGroup({});
  areValidVariationImages: boolean = true;
  stepThreeLabelMessage: string = '';
	@ViewChild('stepThreeContainer') stepThreeContainer: ElementRef<HTMLElement>;
	@ViewChild('stepThreeLabel') stepThreeLabel: ElementRef<HTMLElement>;

  //step 4
  stepFourFormGroup: FormGroup = new FormGroup({});
  stepFourLabelMessage: string = '';
	@ViewChild('stepFourContainer') stepFourContainer: ElementRef<HTMLElement>;
	@ViewChild('stepFourLabel') stepFourLabel: ElementRef<HTMLElement>;

  //step 5
  stepFiveFormGroup: FormGroup = new FormGroup({});
  stepFiveLabelMessage: string = '';
	@ViewChild('stepFiveContainer') stepFiveContainer: ElementRef<HTMLElement>;
	@ViewChild('stepFiveLabel') stepFiveLabel: ElementRef<HTMLElement>;

  private localizationStrings = new Map();

  constructor(
    public cvConfigurationService: CvConfigurationService,
    private pointStoreProductValidationService: PointStoreProductValidationService,
    private changeDetector: ChangeDetectorRef,
    private cvPointStoreProductService: CvPointStoreProductService,
    private cvLocalizationService: CVLocalizationService,
    private pointStoreProductEditService: PointStoreProductEditService,
    private pointStoreProductEditSaveService: PointStoreProductEditSaveService,
    private dialogService: CvCustomDialogService,
    private pointStoreNavigationBarService: PointStoreNavigationBarService) {
    this.isCxone = cvConfigurationService.isCxOne;
    this.stepsNumber = 100 / (this.steppersCompleted.length - 1);
  }

  ngOnInit(): void {
    this.initObserver();
    this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
    this.cvPointStoreProductService.loadMessages();
    this.loadLocalizations();
    this.isEdit = this.pspes.modifiedPointStoreProduct.PointStoreProductID > 0;
    this.createAssignment();
  }

  ngOnDestroy(): void {
    if (this.stepperObserverContainer) {
      this.stepperObserverContainer.disconnect();
    }
    this.modifiedProductCopy = null;
    this.pspes.isSavingProduct = false;
  }

  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }

  ngAfterViewInit() {
    this.fillForm();
    //Create an initial copy of the object to detect changes when user edit
    this.modifiedProductCopy = cloneDeep(this.pspes.modifiedPointStoreProduct);
    if (this.isEdit){
        this.progressbarFilledIn = this.stepsNumber * this.getCurrentWizardIndex();
    }
  }

  /**
   * `loadLocalizations()`, load the localization section.
   */
  loadLocalizations() {
    this.cvLocalizationService.GetSection("MarketPlace_Management").then((map) => {
      this.localizationStrings = map;
    });
  }


  /**
   * The `getLocalizationString()` return the localization key value.
   * @param key key for the localization
   * @param defaultValue the default value to display if the key doesn't exist.
   * @returns the key value.
   */
  getLocalizationString(key, defaultValue) {
    if (this.localizationStrings && this.localizationStrings.has(key))
      return this.localizationStrings.get(key);
    return defaultValue;
  }

private formatDateProperty(obj: any, property: string) {
    if (obj[property]) {
        obj[property] = moment(obj[property]).format('YYYY-MM-DD');
    } else {
        obj[property] = null;
    }
}

  checkProductsEqual() {
    const cloneModifiedProduct = cloneDeep(this.pspes.modifiedPointStoreProduct);
    const dateProperties = ['CarouselStart', 'CarouselEnd', 'FeatureStart', 'FeatureEnd', 'SaleStart', 'SaleEnd', 'ProductStart', 'ProductEnd'];

    dateProperties.forEach(property => {
        this.formatDateProperty(cloneModifiedProduct, property);
        this.formatDateProperty(this.modifiedProductCopy, property);
    });

    return isEqual(cloneModifiedProduct, this.modifiedProductCopy);
  }

  public createAssignment(): void {
      this.selectedAssignment = {
          AssignAll: false,
          Emp: [],
          Level: 0
      };
  }

  private getTeamName(key: number) {
      const teams = this.cvPointStoreProductService.getTeams();
      const foundObject = teams.find(item => item.groupDTO.GroupID === key);
      return foundObject?.groupDTO?.GroupName;
  }

  private fillForm(): void {
      if (this.pspes.modifiedPointStoreProduct.PointStoreProductID == 0 && !this.pspes.copiedProduct) {
          return;
      }

      let index: number = 0;
      for (const emp of this.pspes.modifiedPointStoreProduct.PointStoreProductAllAssignments.emp) {
          this.selectedAssignment.Emp.push(emp);
          this.selectedAssignment.Level = emp.GroupLevel;
          if (this.selectedAssignment.Level === 1) {
              this.selectedAssignment.Emp[index].Email = this.getTeamName(emp.ParentGroupID);
          };
          index++;
      }
  }

  /**
   * The `cancel()` function returns to the `All products` view.
   */
  cancel() {
    this.cvPointStoreProductService.validatePointStoreProductCancelButton(!this.checkProductsEqual());
  }

  /**
   * The `next()` function handles the next step.
   */
  next() {
    if (this.validForm()) {
      if(this.stepper.selectedIndex === 2) {
        this.checkImgVariations();
        //check if it is the last stepper
      } else if ((this.stepper.selectedIndex + 1) < this.steppersCompleted.length) {
        this.stepper.next();
        this.pointStoreProductValidationService.resetImageValidations();
      } else {
        //save
        this.savePointStoreProduct();
      }
    }
  }

  /**
   * The `onselectionChange()` is triggered when the user clicks on a not disabled step.
   * @param event contains the stepper element in the changed event.
   */
  onselectionChange(event) {
    this.pointStoreProductValidationService.resetImageValidations();
    if (event.selectedIndex === 2) {
      this.areValidImageVariations();
    }
    this.progressbarFilledIn = this.stepsNumber * event.selectedIndex;
  }

  /**
   * The `validForm()` validates the current form.
   * @returns the status of the current form.
   */
  validForm(step?: number ): boolean {
    let isValid: boolean = false;
    if (this.stepper) {
      const currentStep = step >= 0 ? step : this.stepper.selectedIndex;
      switch (currentStep) {
        //Product information
        case 0:
          isValid = this.stepOneFormGroup.valid;
          break;
        //Display Setting
        case 1:
          isValid = this.stepTwoFormGroup.valid;
          break;
        //Upload Picture
        case 2:
          isValid = this.stepThreeFormGroup.valid;
          break;
        //Assign Groups
        case 3:
          isValid = this.stepFourFormGroup.valid;
          break;
        //Summary
        case 4:
          isValid = this.stepFiveFormGroup.valid;
          break;
        default:
          isValid = false;
          break;
      }
    }
    return isValid;
  }

  /**
   * `validPreviousForm(index)`, the function validates if the previous forms are valid.
   * @param indexForm current form index to validate.
   * @returns the status of the previous forms.
   */
  validPreviousForm(indexForm: number): boolean {
    let statusForm = false;
    if (this.stepper) {
      switch (indexForm) {
        //Product Info
        case 0:
          statusForm = true;
          break;
        //Display Settings
        case 1:
          statusForm = this.stepOneFormGroup.valid;
          break;
        //Upload Picture
        case 2:
          statusForm = this.stepOneFormGroup.valid && this.stepTwoFormGroup.valid;
          break;
        //Assign Groups
        case 3:
          statusForm = this.stepOneFormGroup.valid && this.stepTwoFormGroup.valid && this.stepThreeFormGroup.valid;
          break;
        //Summary
        case 4:
          statusForm = this.stepOneFormGroup.valid && this.stepTwoFormGroup.valid && this.stepThreeFormGroup.valid && this.stepFourFormGroup.valid;
          break;
        default:
          break;
      }
    }
    return statusForm;
  }


  /**
   * The `initObserver()` starts the observer for the progress indicator size.
   */
  initObserver(): void {
    setTimeout(() => {
      this.stepperObserverContainer = new ResizeObserver(entries => {
        this.stepperIndicatorWidth();
      });
      const divToObserve = document.getElementById('cv-horizontal-stepper');
      this.stepperObserverContainer.observe(divToObserve);
    }, 0);
  }

  /**
   * `stepperIndicatorWidth()` , function to adjust the stepperIndicatorBar width, also to display a tooltip for each stepper.
   */
  stepperIndicatorWidth(): void {
    const parentDiv = document.getElementsByClassName('mat-horizontal-stepper-header-container');
    if (parentDiv) {
      const parentDivTyped = parentDiv[0] as HTMLElement;
      if (this.stepperContainerSize == 0 || parentDivTyped.offsetWidth != this.stepperContainerSize) {
        const leftPaddingContainer = +(window.getComputedStyle(parentDivTyped, null).getPropertyValue('padding-left').replace('px', ''));
        const divChildren = document.getElementsByClassName('mat-step-header');
        const childElementFormatted = divChildren[0] as HTMLElement;
        const childWidth = childElementFormatted.offsetWidth;

        this.stepperIndicatorBar = (leftPaddingContainer + 15 + (childWidth / 2)) + 'px';
        if (this.loadingProgressWrapper) {
          this.loadingProgressWrapper = false;
        }
        this.displayTooltip();
        this.changeDetector.detectChanges();
      }
    }
  }

  displayTooltip(): void {
    //step 1
    if (this.stepOneContainer && this.stepOneLabel) {
      this.stepOneLabelMessage = this.stepOneContainer.nativeElement.offsetWidth < this.stepOneLabel.nativeElement.offsetWidth ? this.getLocalizationString("Product_Info", "Product Info") : '';
    }
    //step 2
    if (this.stepTwoContainer && this.stepTwoLabel) {
      this.stepTwoLabelMessage = this.stepTwoContainer.nativeElement.offsetWidth < this.stepTwoLabel.nativeElement.offsetWidth ? this.getLocalizationString("Display_Settings", "Display Settings") : '';
    }
    //step 3
    if (this.stepThreeContainer && this.stepThreeLabel) {
      this.stepThreeLabelMessage = this.stepThreeContainer.nativeElement.offsetWidth < this.stepThreeLabel.nativeElement.offsetWidth ? this.getLocalizationString("Upload_Images", "Upload Images") : '';
    }
    //step 4
    if (this.stepFourContainer && this.stepFourLabel) {
      this.stepFourLabelMessage = this.stepFourContainer.nativeElement.offsetWidth < this.stepFourLabel.nativeElement.offsetWidth ? this.getLocalizationString("Assign_Groups", "Assign Groups") : '';
    }
    //step 4
    if (this.stepFiveContainer && this.stepFiveLabel) {
      this.stepFiveLabelMessage = this.stepFiveContainer.nativeElement.offsetWidth < this.stepFiveLabel.nativeElement.offsetWidth ? this.getLocalizationString("Summary", "Summary") : '';
    }
  }

  detectChangesParent(): void {
    this.changeDetector.detectChanges();
  }

  /**
   * method to validate if there are pending image variations
   * @param isPreviousStep if I need to go back to step 3
   * @returns 
   */
  checkImgVariations(isPreviousStep: boolean = false): void {
    const isValid = this.pointStoreProductValidationService.validatePendingImageVariations();
    if (isValid) {
      this.validatePendingImgVariationsMsg(isPreviousStep);
    } else {
      this.stepper.next();
    }
  }

  /**
   * method to display the modal with the validation
   * @param isPreviousStep if I need to go back to step 3
   */
  validatePendingImgVariationsMsg(isPreviousStep: boolean): void {
    const modalOptions: NgbModalOptions = {
      keyboard: false,
      backdrop: 'static',
      centered: true,
    };
    const modalTitle = this.cvLocalizationService.getCachedText("MarketPlace_Management_Messages", "Validate_Upload_Img_Variations_Title", "Upload Variation Image");
    const prompt = "<p class='modal-body-text pb-2'>" + this.cvLocalizationService.getCachedText("MarketPlace_Management_Messages", "Validate_Upload_Img_Variations_Body", "Upload all pending variation images. If you don’t have a specific variation image, upload the main image for all variations.") + "</p>";
    const okLabel = this.cvLocalizationService.getCachedText("Common", "Ok", "Ok");
    const modal: NgbModalRef = this.dialogService.showDialog(modalTitle, prompt, 4, '', okLabel, true, () => this.goToPreviousStep(isPreviousStep), () => {}, 'upload-dialog', true, modalOptions);
    //in case the modal is dimissed with the modal close button
    modal.dismissed.subscribe(() => {
      this.goToPreviousStep(isPreviousStep);
    });
  }

  /**
 * method to return to the step 3
 * @param isPreviousStep if I need to go back to step 3
 */
  goToPreviousStep(isPreviousStep: boolean, previousStep = 2): void {
    if (isPreviousStep) {
      this.stepper.selectedIndex = previousStep;
    }
  }

  areValidImageVariations(): void {
    if ((this.pspes.modifiedPointStoreProduct.imageString.length === 0 || !this.pspes.modifiedPointStoreProduct.imageString.some(images => images?.validation === false )) && this.pspes.modifiedPointStoreProduct.HasProductVariations) {
      let numberOfImages: number = 0;
      for (const variation of this.pspes.modifiedPointStoreProduct.VariationsData) {
        if (variation.VariationImageData !== undefined && variation.VariationImageData !== null) {
          numberOfImages++;
        }
      }
      //empty image variations
      if (numberOfImages === 0) {
        this.updateVariationImagesValidation(true);
        //the number of images are equal to VariationsData.length
      } else if (numberOfImages === this.pspes.modifiedPointStoreProduct.VariationsData.length) {
        this.updateVariationImagesValidation(true);
        //VariationsData.length is not equal to numberOfImages;
      } else {
        this.updateVariationImagesValidation(false);
      }
    } else {
      this.updateVariationImagesValidation(true);
    }
  }

  updateVariationImagesValidation(event: boolean) {
    this.areValidVariationImages = event;
    let headerSteps = document.getElementsByClassName('mat-step-header');
    if (headerSteps) {
      if (event) {
        const s = document.getElementById('disable-by-variation-images-1');
        if (s) s.remove();
        const t = document.getElementById('disable-by-variation-images-2');
        if (t) t.remove();
      } else {
        const vs = document.getElementById('disable-by-variation-images-1');
        if(vs) return;

        const s = document.createElement('div');
        s.innerHTML = '';
        s.id = 'disable-by-variation-images-1';
        s.addEventListener("click", () => {
          this.validatePendingImgVariationsMsg(false);
        });
        headerSteps[2].insertAdjacentElement("beforebegin", s);

        const t = document.createElement('div');
        t.innerHTML = '';
        t.id = 'disable-by-variation-images-2';
        t.addEventListener("click", () => {
          this.validatePendingImgVariationsMsg(false);
        });
        headerSteps[2].insertAdjacentElement("afterend", t);
      }
    }
  }

  /**
   * method to save the product
   */
  savePointStoreProduct() {
    if (this.pspes.isSavingProduct)
    return;

    this.pspes.isSavingProduct = true;

    const validation = this.pointStoreProductValidationService.validatePointStoreProductEditPageCXOne();
    if (validation.idError !== 0) {
      this.displayErrorById(validation);
      this.pspes.isSavingProduct = false;
    } else {
      //remove variations if the product not have variations
      if (!this.pspes.modifiedPointStoreProduct.HasProductVariations) {
        this.pspes.modifiedPointStoreProduct.VariationsData = [];
      }
      if (!this.checkSaleVariations()) {
        this.pspes.isSavingProduct = false;
        return;
      }
      const { modifiedPointStoreProduct: product } = this.pspes;

      // Remove format from number fields before save
      ['Price', 'Quantity'].forEach(field => {
        product[field] = product[field] ? this.removeNumberFormat(product[field]) : product[field];
      });

      // Variation price and quantity
      if (product.HasProductVariations) {
        product.VariationsData.forEach(variation => {
            ['VariationPrice', 'VariationQuantity'].forEach(field => {
                variation[field] = variation[field] ? this.removeNumberFormat(variation[field]) : variation[field];
            });
        });
      }

      this.pointStoreProductEditSaveService.savePointStoreProductCXOne().then((result) => {
        if (result != null) {
          //refresh the product list
          this.callParentFunctions();
          this.pspes.isSavingProduct = false;
          // //boolean variable to decide if reload the categories in the product info form, false to no reload
          // this.pscs.isCategoriesChange = false;
          // //reset category list on the product info form
          // this.pointStoreCategoriesService.resetCategoriesList();
        } else {
          this.pspes.isSavingProduct = false;
        }
      })
        .catch((error) => {
          this.pspes.isSavingProduct = false;
        });
    }
  }

  displayErrorById(validation: PointStoreProductSaveValidation) {
    switch (validation.idError) {
      case 42:
        this.validatePendingImgVariationsMsg(true);
        break;    
      default:
        break;
    }
  }

  getCurrentWizardIndex(): number {
    return this.pointStoreNavigationBarService.getWizardIndex();
  }

  getWizardHeader(): string {
    if (this.pspes.modifiedPointStoreProduct.PointStoreProductID === 0 && !this.pspes.copiedProduct) {
        return this.getLocalizationString("New_Product", "New Product");
    } else if (this.pspes.modifiedPointStoreProduct.PointStoreProductID > 0) {
        return this.getLocalizationString("Edit_Product", "Edit Product");
    } else {
        return this.getLocalizationString("Duplicate_Product", "Duplicating Product");
    }
  }

  validateStepper(isPreviousStep: boolean): void {
    const modalOptions: NgbModalOptions = {
      keyboard: false,
      backdrop: 'static',
      centered: true,
    };
    const modalTitle =this.cvLocalizationService.getCachedText("MarketPlace_Management", "Display_Settings", "Display Settings");
    const prompt = "<p class='modal-body-text pb-2'>" + this.cvLocalizationService.getCachedText("MarketPlace_Management_Messages", "Check_Discount_Settings", "Check the discount settings.")  + "</p>";
    const okLabel = this.cvLocalizationService.getCachedText("Common", "Ok", "Ok");
    const modal: NgbModalRef = this.dialogService.showDialog(modalTitle, prompt, 4, '', okLabel, true, () => this.goToPreviousStep(isPreviousStep, 1), () => {}, 'upload-dialog', true, modalOptions);
    //in case the modal is dimissed with the modal close button
    modal.dismissed.subscribe(() => {
      this.goToPreviousStep(isPreviousStep, 1);
    });
  }
  
  checkSaleVariations() {
    let itemsOnSale = 0;
    let variationSaleIsValid = false;
    if (this.pspes.modifiedPointStoreProduct != undefined && this.pspes.modifiedPointStoreProduct.VariationsData != undefined && this.pspes.settingPointStoreProduct != null) {
      if (this.pspes.modifiedPointStoreProduct.HasProductVariations) {
        this.pspes.modifiedPointStoreProduct.VariationsData.forEach((variation) => {
          if (variation.VariationOnSale) {
            variationSaleIsValid = true;
            itemsOnSale++;
          }
        });
        if (variationSaleIsValid) {
          return variationSaleIsValid;
        }else if (this.pspes.modifiedPointStoreProduct.Sale != null) {
          this.validateStepper(true);
            return variationSaleIsValid;
        } else {
            variationSaleIsValid = true;
            return variationSaleIsValid;
        }
      } else {
        variationSaleIsValid = true;
        return variationSaleIsValid;
      }
    }
  }
  
  removeNumberFormat(value: string | number): number {
    const valueWithoutCommasAndDots = value.toString().replace(/,/g, '').replace(/\./g, '');
    return parseFloat(valueWithoutCommasAndDots);
  }
}
